import { styled, Typography } from '@mui/material';

const Title = styled(Typography)(({ theme }) => ({
  fontFamily : 'Montserrat',
  fontWeight : '700',
  fontSize   : '24px',
  fontStyle  : 'normal',
  lineHeight : '42px',
  color      : theme.palette.primary.gray8,
}));

export default Title;
